module.exports = __webpack_public_path__ + "img/negin.740556bd.jpg";